import React from 'react';
import { useStoreon } from 'storeon/react';
import { useFieldArray } from 'react-hook-form';
import PropTypes from 'prop-types';
import Radios from '../Radios';

const WhoToContact = (props) => {
  const { index: blockIndex, number = true } = props;
  const { groups } = useStoreon('groups');
  const { fields } = useFieldArray({
    name: 'your_project',
  });

  return (
    <fieldset className="form-block" disabled={groups[blockIndex].disabled}>
      <legend className="form-block__title">{number ? blockIndex + 1 + '.' : ''} Who should be contacted for this service</legend>
      {fields.map((item) => {
        return (
          <div className={`block-form block--describe-your-problem`} key={item.id}>
            <div className={`block-form block--describe-your-problem`} key={item.id}>
              <Radios
                label=""
                name="contact_subject"
                options={[
                  {
                    value: 'Dealer',
                    label: 'Dealer',
                  },
                  {
                    value: 'Customer',
                    label: 'Customer',
                  },
                  {
                    value: 'Both',
                    label: 'Both',
                  },
                ]}
                defaultValue={'Dealer'}
                rules={{
                  required: 'This field is required.',
                }}
              />
            </div>
          </div>
        );
      })}
      {!groups[blockIndex].disabled &&
        groups[blockIndex + 1] &&
        groups[blockIndex + 1].disabled && (
          <div className={'form-block__error'}>
            You must fill in all required fields prior to moving to the next section.
          </div>
        )}
    </fieldset>
  );
};

WhoToContact.propTypes = {
  index: PropTypes.number.isRequired,
};

export default WhoToContact;
